import { withTranslation } from '../Translator';

import ReportDateRangePicker from './ReportDateRangePicker';

export default withTranslation('components')(ReportDateRangePicker);
